import {ActionIcon, Affix, Tooltip} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import {IconMessageExclamation} from '@tabler/icons-react';
import {FeedbackModal} from './FeedbackModal';

export const FeedbackFloatingIcon = () => {
    const [opened, {open, close}] = useDisclosure(false);

    return (
            <>
                <Affix position={{bottom: 40, right: 40}}>
                    <Tooltip
                            label={
                                <div style={{textAlign: 'center'}}>
                                    <div>Submit Feedback</div>
                                    <div style={{fontSize: '0.875em', opacity: 0.9}}>to the CadCare Connect Team</div>
                                </div>
                            }
                            position="left"
                            withArrow
                    >
                        <ActionIcon
                                color="blue"
                                radius="xl"
                                size={40}
                                onClick={open}
                                aria-label="submit-feedback"
                        >
                            <IconMessageExclamation size={24}/>
                        </ActionIcon>
                    </Tooltip>
                </Affix>

                <FeedbackModal opened={opened} onClose={close}/>
            </>
    );
};